// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d9oY","left":"styles_left__2RvQX","desktopActions":"styles_desktopActions__1qAr8","title":"styles_title__2RCWp"};